import React from 'react';
import LocalizedMessage from 'react-l10n';
import OrderList from './OrderList';
import { getTranslation } from '../lang/main';
import { currencyDisplay, currencyObject } from '../_utils';
import { convertPaymentMethodToAReadableFormat } from '../selectors/converterSelector';

function CustomerOrdersApproved(props) {

    // Functions
    const getApprovedCustomerOrdersCallback = () => {
        return {
            updateListParams: (listParams) => {
                listParams['filters']['View'] = 'customer_orders';
                listParams['filters']['ApprovedOnly'] = true;

                return listParams;
            },
            updateTableProps: (
                tableProps,
                { loadOrder, toggleViewOrderModal, toggleRefineResultsModal }
            ) => {
                tableProps.list.columns = [
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading hidden-xs'>
                                        <LocalizedMessage id={'ORDER_NUMBER'} />
                                    </span>
                                    <span className='react-table__heading visible-xs'>
                                        <LocalizedMessage id={'ORDER_NO'} />
                                    </span>
                                    <span className='react-table__sort-icon' />
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        minWidth: undefined,
                        accessor: 'InternalItemID',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'SOLD_BY'} />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            const { BusinessName, FirstName, Surname } = row.value;

                            if (BusinessName) {
                                return (
                                    <React.Fragment>
                                        <span className='react-table__info'>
                                            {BusinessName}
                                        </span>
                                    </React.Fragment>
                                );
                            }

                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {`${FirstName} ${Surname}`}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        sortable: false,
                        headerClassName: 'hidden-xs',
                        className: 'hidden-xs',
                        minWidth: undefined,
                        accessor: 'ParentMember',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'ORDERED_BY'} />
                                    </span>
                                    <span className='react-table__sort-icon' />
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            const { BusinessName, FirstName, Surname } = row.original;

                            if (BusinessName) {
                                return (
                                    <React.Fragment>
                                        <span className='react-table__info'>
                                            {BusinessName}
                                        </span>
                                    </React.Fragment>
                                );
                            }

                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {`${FirstName} ${Surname}`}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        minWidth: undefined,
                        accessor: 'BusinessName',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'DATE_ORDERED'} />
                                    </span>
                                    <span className='react-table__sort-icon' />
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.original.PlacedNice}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        minWidth: undefined,
                        accessor: 'Placed',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading hidden-xs'>
                                        <LocalizedMessage id={'ORDER_STATUS'} />
                                    </span>
                                    <span className='react-table__heading visible-xs'>
                                        <LocalizedMessage id={'STATUS'} />
                                    </span>
                                    <span className='react-table__sort-icon' />
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        minWidth: undefined,
                        accessor: 'Status',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'CONTAINS'} />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        sortable: false,
                        minWidth: undefined,
                        accessor: 'ContainItemTypes',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage
                                            id={'PAYMENT_TYPE'}
                                        />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {convertPaymentMethodToAReadableFormat(row.value)}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        sortable: false,
                        minWidth: undefined,
                        accessor: 'PaymentMethod',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'TOTAL'} />
                                    </span>
                                    <span className='react-table__sort-icon' />
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            const { CurrencyDisplayCode, CurrencyFormat } = row.original;
                            const { locale } = currencyObject;

                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {currencyDisplay(row.value, CurrencyDisplayCode, CurrencyFormat, locale)}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'hidden-xs',
                        className: 'hidden-xs',
                        minWidth: undefined,
                        accessor: 'Total',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage
                                            id={'CARRIER'}
                                        />
                                    </span>
                                    <span className='react-table__sort-icon' />
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'hidden-xs',
                        className: 'hidden-xs',
                        minWidth: undefined,
                        accessor: 'ShippingMethod',
                    },
                    {
                        expander: true,
                        Expander: ({ isExpanded, ...rest }) => {
                            return (
                                <React.Fragment>
                                    <button
                                        type='button'
                                        className='react-table__extra-data-toggle'
                                    >
                                        <span className='icon icon-chevron-thick' />
                                    </button>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'visible-xs',
                        className: 'visible-xs',
                        width: 45,
                        sortable: false,
                        accessor: 'ID',
                    },
                ];

                return tableProps;
            },
        };
    };

    const columnsToExportMap = [
        { key: 'InternalItemID', column: 'Order Number/ID' },
        { key: 'ParentMember', column: 'Sold By' },
        { key: 'BusinessName', column: 'Ordered By' },
        { key: 'PlacedNice', column: 'Date Ordered' },
        { key: 'Status', column: 'Order Status' },
        { key: 'ContainItemTypes', column: 'Contains' },
        { key: 'PaymentMethod', column: 'Payment Type' },
        { key: 'Total', column: 'Total' },
        { key: 'ShippingMethod', column: 'Carrier' }
    ];

    return (
        <React.Fragment>
            <div className='vspace'>
                <OrderList
                    className='card--stackable'
                    heading={getTranslation(
                        'CUSTOMER_ORDERS.APPROVED.HEADING'
                    )}
                    refineResultsModalKey='refine-results-customer-orders-awaiting-approval-list'
                    viewOrderModalKey='view-customer-order-awaiting-approval-modal'
                    callback={getApprovedCustomerOrdersCallback()}
                    showStatus='ShippingStatus'
                    sortBy='Placed'
                    sortDirection='ASC'
                    getOrderDetailLink={(row) => `${window.baseURL}checkout/confirmation/${row.original.ID}/?type=customer-orders-approved`}
                    columnsToExportMap={columnsToExportMap}
                />
            </div>
        </React.Fragment>
    );
}

export default CustomerOrdersApproved;
